import { CircularProgress } from "@mui/material";
import { useCampaignLeads } from "./useMarketing";

const MAX_AGE_NOTE = "Showing the newest leads. Older ones are in Meta Leads Center.";

export function answerLabel(name) {
  const text = (name || "").replace(/_/g, " ").trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : "Answer";
}

function formatReceived(value) {
  if (!value) return "-";
  return new Date(value).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" });
}

function LeadRow({ lead }) {
  return (
    <li className="rounded border border-app-border p-3 text-sm">
      <p className="mb-1 text-xs text-app-text-muted">{formatReceived(lead.receivedAt)}</p>
      <dl className="grid grid-cols-[auto,1fr] gap-x-3 gap-y-1">
        {lead.answers.map((answer) => (
          <div key={answer.name} className="contents">
            <dt className="text-app-text-secondary">{answerLabel(answer.name)}</dt>
            <dd className="break-words">{answer.values.join(", ") || "-"}</dd>
          </div>
        ))}
      </dl>
    </li>
  );
}

export default function LeadsSection({ campaignId }) {
  const { data, isLoading, isError, error, refetch } = useCampaignLeads(campaignId, true);
  const leads = data?.leads || [];
  return (
    <section>
      <h3 className="mb-2 font-semibold">Leads</h3>
      <p className="mb-2 text-xs text-app-text-muted">
        Read from Meta when you open this campaign and not saved here. Contains personal details.
      </p>
      {isLoading ? <CircularProgress size={20} /> : null}
      {isError ? (
        <div className="text-sm">
          <p className="text-app-status-cancelled-text">
            {error?.response?.data?.errorMessage || "Could not load leads from Meta."}
          </p>
          <p className="text-app-text-secondary">
            The token needs leads_retrieval. Run Test connection under Connection to check.
          </p>
          <button type="button" className="underline" onClick={() => refetch()}>
            Try again
          </button>
        </div>
      ) : null}
      {data && leads.length === 0 ? (
        <p className="text-sm text-app-text-secondary">No leads yet.</p>
      ) : null}
      <ul className="space-y-2">
        {leads.map((lead) => (
          <LeadRow key={lead.id} lead={lead} />
        ))}
      </ul>
      {data?.more ? <p className="mt-2 text-xs text-app-text-muted">{MAX_AGE_NOTE}</p> : null}
    </section>
  );
}
